<div>
  <span
    [class]="cssClasses ? cssClasses.error.icon : 'panel-error-icon'"
    aria-hidden="true"
  ></span>
  <span [class]="cssClasses ? cssClasses.error.item : 'panel-error-item'" [model]="error.locText" sv-ng-string>
  </span>
</div>